var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgWarningRed = function SvgWarningRed(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.72 11.818 9.256 2.326a1.422 1.422 0 0 0-2.452 0l-5.466 9.492a1.346 1.346 0 0 0 0 1.357 1.397 1.397 0 0 0 1.226.7h10.931a1.397 1.397 0 0 0 1.41-1.378c0-.239-.063-.473-.183-.68zm-.65.982a.654.654 0 0 1-.575.325H2.563a.654.654 0 0 1-.575-.325.594.594 0 0 1 0-.608L7.453 2.7a.672.672 0 0 1 1.152 0l5.466 9.492a.595.595 0 0 1 0 .608zM7.654 9V6.5a.375.375 0 0 1 .75 0V9a.375.375 0 0 1-.75 0zm1 2.25a.625.625 0 1 1-1.25 0 .625.625 0 0 1 1.25 0z",
    fill: "#DA492F"
  })));
};

export default SvgWarningRed;